import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the communications state domain
 */

const selectCommunicationsDomain = state =>
  state.communications || initialState;

/**
 * Other specific selectors
 */

const selectCommunicationDetail = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.itemDetail,
  );

const makeSelectItemsList = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.itemsList,
  );

const makeSelectItemsListAllData = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.allData,
  );
  
const makeSelectItemsListTotalAmount = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.totalAmount,
  );
  
const makeSelectItemsListFilteringParams = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.params,
  );

const makeSelectItemsListNoMore = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.noMore,
  );

const makeSelectItemsListPages = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.pages,
  );

const selectCommunicationsLoading = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.loading,
  );

const makeSelectLoadingUpdate = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.loadingUpdate,
  );
const makeSelectUpdateSuccessful = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.updateSuccessful,
  );
const makeSelectUpdateError = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.errorUpdate,
  );



const selectCommunicationsError = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.error,
  );

const makeSelectId = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.id,
  );

const makeSelectFirstRender = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.firstRender,
  );

const makeSelectInitialID= () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.initialID,
  );

const makeSelectItemsListFirstElem = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.firstElem,
  );

const makeSelectListActiveElem = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.activeElement,
  );

const makeSelectHardDeleteLoading= () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.hardDeleteLoading,
  );
const makeSelectHardDeleteSuccessful = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.hardDeleteSuccessful,
  );

// COPY
const makeSelectToCopyID = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.toCopyID,
  );
const makeSelectCopyLoading = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.copyLoading,
  );
const makeSelectCopySuccessful = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.copySuccessful,
  );
const makeSelectCopyError = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.copyError,
  );

// NEW

const makeSelectIsNew = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.isNew,
  );

const makeSelectIsNewSuccessful = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.isNewSuccessful,
  );

// LOAD SINGLE
const makeSelectLoadDetail = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.loadDetail,
  );

// LOAD SINGLE Answers
const makeSelectLoadAnswers = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.answers,
  );
const makeSelectAnswersLoading = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.loadAnswers,
  );
const makeSelectAnswersError = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.errorAnswers,
  );

// UPDATE SINGLE Answers
const makeSelectPlan = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.planData,
  );
const makeSelectPlanLoading = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.updatePlan,
  );
const makeSelectPlanSuccess = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.updatePlanSuccessful,
  );
const makeSelectPlanError = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate.errorPlan,
  );
  

/**
 * Default selector used by Communications
 */
const makeSelectCommunications = () =>
  createSelector(
    selectCommunicationsDomain,
    substate => substate,
  );
export default makeSelectCommunications;
export {
  selectCommunicationsDomain,
  selectCommunicationsLoading,
  makeSelectLoadingUpdate,
  makeSelectHardDeleteLoading,
  selectCommunicationsError,
  makeSelectHardDeleteSuccessful,
  selectCommunicationDetail,
  makeSelectFirstRender,
  makeSelectId,
  makeSelectUpdateError,
  makeSelectInitialID,
  makeSelectItemsListPages,
  // copy
  makeSelectToCopyID,
  makeSelectCopyLoading,
  makeSelectCopySuccessful,
  makeSelectCopyError,
  // list
  makeSelectItemsListAllData,
  makeSelectItemsList,
  makeSelectItemsListFirstElem,
  makeSelectItemsListFilteringParams,
  makeSelectItemsListNoMore,
  makeSelectItemsListTotalAmount,
  makeSelectListActiveElem,
  // deatils
  makeSelectLoadDetail,
  // load deatils answers
  makeSelectLoadAnswers,
  makeSelectAnswersLoading,
  makeSelectAnswersError,
  // update deatils answers
  makeSelectPlan,
  makeSelectPlanLoading,
  makeSelectPlanSuccess,
  makeSelectPlanError,
  // new
  makeSelectIsNew,
  makeSelectIsNewSuccessful,
  // update
  makeSelectUpdateSuccessful,
};
